import { api } from './NetworkUtility';
import { logError } from './ErrorService';

export const getSinglePayment = (companyNumber, paymentUUID, callbackHandler) => {

    const url = `/companies/${companyNumber}/payments/uuid/${paymentUUID}`;

    api.get(url)
        .then(response => {
            return response.data;
        })
        .then(data => {
            callbackHandler(data)
        })
        .catch(function (error) {
            //navigate hook does not work here, using window.location to redirect
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?sp";
                });
            } else {
                //TODO: add an error handler to the caller of this
                console.log("Unable to retrieve Disbursement information.");
            }
        });
}

export const getPaymentInfo = (companyNumber, paymentUUID, callbackHandler) => {

    const url = `/companies/${companyNumber}/payments/paymentInfo/${paymentUUID}`;    

        api.get(url)
        .then(response => {
            return response.data;
        })
        .then(data => {
            callbackHandler(data)
        })
        .catch(function (error) {
            //navigate hook does not work here, using window.location to redirect
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?sp";
                });
            } else {
                //TODO: add an error handler to the caller of this
                console.log("Unable to retrieve Payment Info.");
            }
        });
}

export const getCsv = (requestOptions, companyNumber, successHandler, errorHandler) => {

    const url = `/companies/${companyNumber}/payments/export`;

    api.post(url, requestOptions, { responseType: 'blob' })
        .then(response => {
            successHandler();
            // download data
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'PreferPay Insights Export.csv');
            document.body.appendChild(link);
            link.click();
            link.remove();
        })
        .catch((error) => {
            //navigate hook does not work here, using window.location to redirect
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?csv";
                });
            } else {
                errorHandler();
            }
        });
}

export const stopPayment = (disbursementUuid, companyNumber, callbackHandler) => {

    const url = `/companies/${companyNumber}/stopPayment/${disbursementUuid}`;

    api.post(url)
    .then(response => {
        callbackHandler(response);
    })
    .catch(error => {
        callbackHandler(error.response);
    });
}